// Sort constants as defined in ant table documentation
export const ANT_ASCENDING = 'ascend';
export const ANT_DESCENDING = 'descend';

// Constants to be send to api
export const API_ASCENDING = 'asc';
export const API_DESCENDING = 'desc';
